import React from 'react';
import PropTypes from 'prop-types';

import usePreviewMode from 'hooks/usePreviewMode';
import { PreviewModeDataContext } from 'contexts/PreviewModeDataContext/index';

const PreviewModeDataContextProvider = ({ children }) => {
  const { data, isPreview } = usePreviewMode();

  const value = {
    previewData: data,
    isPreview
  };

  return (
    <PreviewModeDataContext.Provider value={value}>
      {children}
    </PreviewModeDataContext.Provider>
  );
};

PreviewModeDataContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default PreviewModeDataContextProvider;
